
    import './styles.scoped.css';
    export default {
  "upload-button": "awsui_upload-button_4xu1k_lg6er_99",
  "upload-input": "awsui_upload-input_4xu1k_lg6er_100",
  "file-input-container": "awsui_file-input-container_4xu1k_lg6er_104",
  "force-focus-outline": "awsui_force-focus-outline_4xu1k_lg6er_113"
};
  